const WorksheetHitCode = {
	NONE: 0,
	SHEET: 1,
	COLUMN: 2,
	ROW: 3,
	COLUMNSIZE: 4,
	ROWSIZE: 5,
	CORNER: 6,
	SELECTIONMOVE: 7,
	REFERENCEMOVE: 8,
	REFERENCERESIZE: 9,
	SELECTIONEXTEND: 10,
	ROWSIZEHIDDEN: 11,
	COLUMNSIZEHIDDEN: 12,
	COLUMNOUTLINE: 13,
	ROWOUTLINE: 14,
	DATAVIEW: 15,
	ERRORVIEW: 16,
	PREDECESSOR: 17,
	DEPENDANT: 18,
	CELLPAYLOAD: 19,
};

export default WorksheetHitCode;
